// extracted by mini-css-extract-plugin
export default {"primary-hero":"Button_primary-hero__PlQb9","secondary-hero":"Button_secondary-hero__-VKcQ"};